module.exports = __webpack_public_path__ + "static/img/login-background.84f3dc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-background.jpg
// module id = fifj
// module chunks = 1